import { exists } from '@nu-art/ts-common';
export const snippetHasVariablesWithDefaultValues = (snippet) => {
    return snippet.formVariables?.some(formVar => formVar.isCommon && exists(formVar.defaultValueId));
};
export const fillDefaultFormVariables = (editable, snippet) => {
    const formVariables = snippet.formVariables;
    const isChiefComplaint = snippet.config.produceChiefComplaint;
    formVariables?.forEach(formVar => {
        if (!(formVar.isCommon && exists(formVar.defaultValueId)))
            return;
        const editableVar = editable.editProp(formVar.id, []);
        if (exists(editableVar.item[0]?.valueId))
            return;
        editableVar.updateArrayAt({
            valueId: formVar.defaultValueId,
            snippetId: snippet._id,
            isChiefComplaint: isChiefComplaint ?? false,
            attributes: {},
        }, 0);
    });
};
//# sourceMappingURL=utils.js.map